import React, { Component } from "react";
import { currenySymbol, formatDate } from "../../../actions/Util";

class DetailRow extends Component {
  renderValue = () => {
    const { value, type } = this.props;

    if (value === null || value === undefined || value === "") {
      if (type === "number" || type === "currency") return "0";
      return "-";
    }

    if (typeof value === "boolean") return value ? "Yes" : "No";

    // HTML rendering
    if (type === "html" && typeof value === "string") {
      return (
        <div
          style={{
            maxWidth: "100%",
            overflowX: "auto"
          }}
          dangerouslySetInnerHTML={{ __html: value }}
        />
      );
    }

    if (React.isValidElement(value)) return value;

    if (typeof value === "object" && !Array.isArray(value)) {
      const hasLabel = Object.prototype.hasOwnProperty.call(value, "label");
      const hasValue = Object.prototype.hasOwnProperty.call(value, "value");

      if (hasLabel && hasValue) return value.label;

      return JSON.stringify(value);
    }

    if (Array.isArray(value)) {
      return value.join(", ");
    }

    return value;
  };

  render() {
    const currencySymbol = currenySymbol();

    const hasCondition = Object.prototype.hasOwnProperty.call(
      this.props,
      "condition"
    );
    const hasPl = Object.prototype.hasOwnProperty.call(this.props, "pl");
    const hasWidth = Object.prototype.hasOwnProperty.call(
      this.props,
      "width"
    );
    const hasShowBold = Object.prototype.hasOwnProperty.call(
      this.props,
      "showBold"
    );
    const hasShowValueAtRight = Object.prototype.hasOwnProperty.call(
      this.props,
      "showValueAtRight"
    );
    const hasDontShowAtRightSide = Object.prototype.hasOwnProperty.call(
      this.props,
      "dontShowAtRightSide"
    );

    const label = this.props.label;
    const condition = hasCondition ? this.props.condition : true;
    const pl = hasPl ? this.props.pl : "5";
    const width = hasWidth ? this.props.width : "150px";
    const showBold = hasShowBold ? this.props.showBold : false;
    const showValueAtRight = hasShowValueAtRight
      ? this.props.showValueAtRight
      : false;
    const type = this.props.type;
    const dontShowAtRightSide = hasDontShowAtRightSide
      ? this.props.dontShowAtRightSide
      : false;

    if (!condition) return null;

    const labelStyle = {
      paddingTop: "6px",
      paddingBottom: "6px",
      width: width,
      color: showBold ? "#000000" : "var(--list-item-gray)",
      fontWeight: showBold ? 600 : "normal",
      verticalAlign: "top"
    };

    const valueStyle = {
      paddingTop: "6px",
      paddingBottom: "6px",
      paddingLeft: `${pl}px`,
      color: "#000000",
      fontWeight: showBold ? 600 : "normal",
      textAlign:
        ((showValueAtRight ||
          type === "currency" ||
          type === "number") &&
          !dontShowAtRightSide)
          ? "right"
          : "left",
      verticalAlign: "top"
    };

    return (
      <tr style={{ verticalAlign: "top" }}>
        <td style={labelStyle}>{label}</td>

        <td style={valueStyle}>
          {type === "currency"
            ? `${currencySymbol}${this.renderValue()}`
            : type === "date"
            ? formatDate(this.renderValue())
            : this.renderValue()}
        </td>
      </tr>
    );
  }
}

export default DetailRow;